<template>
	<div @keydown="getKeyCode" class="editor" v-if="editor">
		<!--         @focusin="changeFocusIn" @focusout="changeFocusOut"-->
		<!--    >-->
		<editor-content class="editor__content" :editor="editor" />
	</div>
</template>
<script>
import Variable from "./variable.ts"
import { EditorContent } from "@tiptap/vue-2"
import MenuBar from "./MenuBar.vue"

export default {
	components: {
		EditorContent,
		MenuBar,

		Variable
	},
	props: ["editor"],
	render(createElement) {
		return createElement("div")
	},
	data() {
		return {
			provider: null,
			indexdb: null,
			users: [],
			status: "connecting",
			varPopup: false,
			focused: true,
			commands: undefined,
			actualCommand: undefined
		}
	},
	mounted() {},
	methods: {
		changeFocusIn(act) {
			this.focused = true
		},
		changeFocusOut(act) {
			this.focused = false
		},
		getKeyCode(event) {
			if (!event.ctrlKey) {
				switch (event.key) {
					case "/": // init popup comandi quando si inserisce /
						//todo
						event.preventDefault()
						this.actualCommand = "/"
						// this.commandPosition = this.editorInstance.getSelection() || 0
						this.initPopup(1)
						break
					case "Enter": // creazione nuovo editor quando si preme invio
						this.$emit("newBelow")
return false
						break
					case "Backspace":
						if (!this.editor.state.doc.textContent.length) {
							this.$emit("delRow")
						}

						break
					case "$": // init popup variabili quando si preme $
						event.preventDefault()
						this.actualCommand = "$"

						this.initPopup(2)
						break
					default:
						// this.actualCommand = ''
						break
				}
			}
		},
		initPopup(i) {
			if (i === 1) {
				this.actualCommand = "/"
				this.$emit("cmdpop")
			} else {
				// popup variabili

				this.actualCommand = "$"
				this.$emit("varpop")
			}
		}
	},
	beforeDestroy() {
		this.editor.element = this.$el
		this.editor.destroy()
	}
}
</script>
<style lang="scss" scoped>
.editor {
	display: flex;
	flex-direction: column;
	max-height: 400px;
	color: #0d0d0d;
	background-color: white;
	//border: 3px solid #0D0D0D;
	border-radius: 0.75rem;

	&__header {
		display: flex;
		align-items: center;
		flex: 0 0 auto;
		flex-wrap: wrap;
		padding: 0.25rem;
		margin-bottom: 10px;
		border-bottom: 3px solid #0d0d0d;
	}

	&__content {
		padding: 0.3rem 0.1rem;
		flex: 1 1 auto;
		overflow-x: hidden;
		overflow-y: auto;
		-webkit-overflow-scrolling: touch;
	}

	&__footer {
		display: flex;
		flex: 0 0 auto;
		align-items: center;
		justify-content: space-between;
		flex-wrap: wrap;
		white-space: nowrap;
		border-top: 3px solid #0d0d0d;
		font-size: 12px;
		font-weight: 600;
		color: #0d0d0d;
		white-space: nowrap;
		padding: 0.25rem 0.75rem;
	}

	/* Some information about the status */
	&__status {
		display: flex;
		align-items: center;
		border-radius: 5px;

		&::before {
			content: " ";
			flex: 0 0 auto;
			display: inline-block;
			width: 0.5rem;
			height: 0.5rem;
			background: rgba(#0d0d0d, 0.5);
			border-radius: 50%;
			margin-right: 0.5rem;
		}

		&--connecting::before {
			background: #616161;
		}

		&--connected::before {
			background: #b9f18d;
		}
	}

	&__name {
		button {
			background: none;
			border: none;
			font: inherit;
			font-size: 12px;
			font-weight: 600;
			color: #0d0d0d;
			border-radius: 0.4rem;
			padding: 0.25rem 0.5rem;

			&:hover {
				color: #fff;
				background-color: #0d0d0d;
			}
		}
	}
}
</style>
<style lang="scss">
/* Give a remote user a caret */
.collaboration-cursor__caret {
	position: relative;
	margin-left: -1px;
	margin-right: -1px;
	border-left: 1px solid #0d0d0d;
	border-right: 1px solid #0d0d0d;
	word-break: normal;
	pointer-events: none;
}

/* Render the username above the caret */
.collaboration-cursor__label {
	position: absolute;
	top: -1.4em;
	left: -1px;
	font-size: 12px;
	font-style: normal;
	font-weight: 600;
	line-height: normal;
	user-select: none;
	color: #0d0d0d;
	padding: 0.1rem 0.3rem;
	border-radius: 3px 3px 3px 0;
	white-space: nowrap;
}

/* Basic editor styles */
.ProseMirror {
	> * + * {
		margin-top: 0.75em;
	}

	ul,
	ol {
		padding: 0 1rem;
	}

	h1,
	h2,
	h3,
	h4,
	h5,
	h6 {
		line-height: 1.1;
	}

	code {
		background-color: rgba(#616161, 0.1);
		color: #616161;
	}

	pre {
		background: #0d0d0d;
		color: #fff;
		font-family: "JetBrainsMono", monospace;
		padding: 0.75rem 1rem;
		border-radius: 0.5rem;

		code {
			color: inherit;
			padding: 0;
			background: none;
			font-size: 0.8rem;
		}
	}

	mark {
		background-color: #faf594;
	}

	img {
		max-width: 100%;
		height: auto;
	}

	hr {
		margin: 1rem 0;
	}

	blockquote {
		padding-left: 1rem;
		border-left: 2px solid rgba(#0d0d0d, 0.1);
	}

	hr {
		border: none;
		border-top: 2px solid rgba(#0d0d0d, 0.1);
		margin: 2rem 0;
	}

	ul[data-type="taskList"] {
		list-style: none;
		padding: 0;

		li {
			display: flex;
			align-items: center;

			> label {
				flex: 0 0 auto;
				margin-right: 0.5rem;
			}
		}
	}
}

/* Table-specific styling */
.ProseMirror {
	table {
		border-collapse: collapse;
		table-layout: fixed;
		width: 100%;
		margin: 0;
		overflow: hidden;

		td,
		th {
			min-width: 1em;
			border: 2px solid #ced4da;
			padding: 3px 5px;
			vertical-align: top;
			box-sizing: border-box;
			position: relative;

			> * {
				margin-bottom: 0;
			}
		}

		th {
			font-weight: bold;
			text-align: left;
			background-color: #f1f3f5;
		}

		.selectedCell:after {
			z-index: 2;
			position: absolute;
			content: "";
			left: 0;
			right: 0;
			top: 0;
			bottom: 0;
			background: rgba(200, 200, 255, 0.4);
			pointer-events: none;
		}

		.column-resize-handle {
			position: absolute;
			right: -2px;
			top: 0;
			bottom: -2px;
			width: 4px;
			background-color: #adf;
			pointer-events: none;
		}
	}
}

.tableWrapper {
	overflow-x: auto;
}
</style>
